import { CarrierVisitDirection, CreateRailcarTrackPositionCommand } from '@planning/app/api'
import { FieldStore, ISubFormStore, required, validateSubForm } from '@tom-ui/utils'
import { computed, makeObservable } from 'mobx'

export interface EmptyRailcarFormData {
  railcarId?: number
  railTrackId?: string
  length?: number
  maxPayload?: number
  sequenceNumber?: number
}

export class AddEmptyRailcarFormStore implements ISubFormStore<EmptyRailcarFormData> {
  railcarId: FieldStore<number | undefined>
  railTrackId: FieldStore<string | undefined>
  length: FieldStore<number | undefined>
  maxPayload: FieldStore<number | undefined>
  sequenceNumber: FieldStore<number | undefined>

  constructor(initialValues?: Partial<EmptyRailcarFormData>) {
    makeObservable(this, {
      data: computed,
    })

    this.railcarId = new FieldStore<number | undefined>(initialValues?.railcarId, required())
    this.railTrackId = new FieldStore<string | undefined>(initialValues?.railTrackId, required())
    this.length = new FieldStore<number | undefined>(initialValues?.length)
    this.maxPayload = new FieldStore<number | undefined>(initialValues?.maxPayload)

    this.sequenceNumber = new FieldStore<number | undefined>(
      initialValues?.sequenceNumber,
      required(),
    )
  }

  validate = () => {
    return validateSubForm(this)
  }

  get data(): EmptyRailcarFormData {
    return {
      railcarId: this.railcarId.value,
      railTrackId: this.railTrackId.value,
      length: this.length.value,
      maxPayload: this.maxPayload.value,
      sequenceNumber: this.sequenceNumber.value,
    }
  }

  getCreateCommand(
    railVisitId: number,
    direction: CarrierVisitDirection,
  ): CreateRailcarTrackPositionCommand {
    const d = this.data
    return {
      railcarId: d.railcarId!,
      railTrackId: d.railTrackId!,
      railVisitId,
      railcarLength: d.length,
      railcarMaxPayload: d.maxPayload,
      sequenceNumber: d.sequenceNumber!,
      direction,
    }
  }
}
